import * as React from 'react';
import { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout/Layout';
import RegisterComponent from './components/Login/Register';
import LogInComponent from './components/Login/LogIn';
import PasswordRecoveryComponent from './components/Login/PasswordRecovery';
import ResetPasswordComponent from './components/Login/ResetPassword';
import RegisterFinalComponent from './components/Login/RegisterFinal';
import RegisterErrorComponent from './components/Login/RegisterError';
import AppChooseComponent from './components/Login/AppChoose';
import SettingsComponent from './components/Login/Settings';
import { Policy } from './components/Statute/Policy';


export default class App extends Component {

    public render() {
        return (
            <Layout>
				<Route exact={true} path={['/', '/logowanie/:professionNumber?']} component={LogInComponent} />
                <Route exact={true} path={['/register', '/rejestracja/:professionNumber?']} component={RegisterComponent} />
                <Route path='/passwordrecovery' component={PasswordRecoveryComponent} />
                <Route path='/resetpassword/:id/:code' component={ResetPasswordComponent} />
                <Route path='/register/final' component={RegisterFinalComponent} />
                <Route path='/register/error' component={RegisterErrorComponent} />
                <Route path='/app/choose' component={AppChooseComponent} />
                <Route path='/app/settings' component={SettingsComponent} />
                <Route path='/policy' component={Policy} />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.tsx